import styled from "styled-components";

export const DetailContainer = styled.div`
    display: flex;
    flex-wrap: wrap;
    flex-direction: column;
    justify-content: center;
    background: linear-gradient(135deg, #f5f7fa 0%, #c3cfe2 100%);
    min-height: calc(100vh - 80px);
    padding: 2rem;
`;

export const DetailPart = styled.div`
    display: flex;
    flex-direction: row;
    justify-content: center;
    flex-wrap: wrap;
    align-items: flex-start;
    gap: 2rem;
    margin: 2rem 0;
    padding: 2rem;
    background: white;
    border-radius: 20px;
    box-shadow: 0 10px 30px rgba(0, 0, 0, 0.1);

    @media (max-width: 1250px) {
        justify-content: center;
        flex-direction: column;
        align-items: center;
    }
`;

export const ImgContainer = styled.div`
    background: white;
    padding: 1.5rem;
    border-radius: 20px;
    margin: 1rem;
    box-shadow: 0 8px 25px rgba(0, 0, 0, 0.1);

    img {
        border-radius: 15px;
        max-width: 300px;
        height: auto;
        box-shadow: 0 4px 15px rgba(0, 0, 0, 0.1);
    }
`;

export const HeaderContainer = styled.div`
    background: linear-gradient(135deg, #667eea 0%, #764ba2 100%);
    display: flex;
    justify-content: center;
    align-items: center;
    gap: 2rem;
    margin: 2rem 0;
    padding: 2rem;
    border-radius: 20px;
    box-shadow: 0 8px 25px rgba(0, 0, 0, 0.1);
    color: white;

    h1 {
        font-size: 2.5rem;
        font-weight: 600;
        margin: 0;
        text-shadow: 2px 2px 4px rgba(0, 0, 0, 0.3);
    }

    img {
        width: 120px;
        opacity: 0.9;
    }

    @media (max-width: 768px) {
        flex-direction: column;
        gap: 1rem;
        text-align: center;

        h1 {
            font-size: 2rem;
        }

        img {
            width: 100px;
        }
    }
`;

export const IngredContainer = styled.div`
    width: 400px;
    padding: 1.5rem;
    font-size: 1.1rem;
    margin: 1rem;
    background: white;
    border-radius: 15px;
    box-shadow: 0 8px 25px rgba(0, 0, 0, 0.1);

    div {
        margin: 0.8rem 0;
        padding: 0.5rem;
        background: #f8f9fa;
        border-radius: 8px;
        border-left: 4px solid #667eea;
    }

    p {
        margin: 0;
        color: #333;
        line-height: 1.5;
    }

    @media (max-width: 768px) {
        width: 100%;
        max-width: 400px;
    }
`;

export const OtherPart = styled.div`
    background: white;
    padding: 1.5rem;
    width: 400px;
    text-align: left;
    font-size: 1.1rem;
    margin: 1rem;
    border-radius: 15px;
    box-shadow: 0 8px 25px rgba(0, 0, 0, 0.1);
    color: #333;

    > *:first-child {
        font-size: 1.8rem;
        font-weight: 700;
        color: #667eea;
        margin-bottom: 1rem;
        text-align: center;
    }

    p {
        margin: 0.8rem 0;
        line-height: 1.5;
        color: #555;
    }

    h3 {
        color: #667eea;
        font-weight: 600;
        font-size: 1.3rem;
        margin: 1.5rem 0 1rem 0;
        text-align: center;
    }

    div {
        background: #f8f9fa;
        padding: 1rem;
        border-radius: 10px;
        margin-top: 1rem;
    }

    a {
        display: inline-block;
        margin-top: 1rem;
        padding: 0.8rem 1.5rem;
        background: linear-gradient(135deg, #667eea 0%, #764ba2 100%);
        color: white;
        text-decoration: none;
        border-radius: 25px;
        font-weight: 600;
        transition: all 0.3s ease;
        box-shadow: 0 4px 15px rgba(102, 126, 234, 0.3);

        &:hover {
            transform: translateY(-2px);
            box-shadow: 0 6px 20px rgba(102, 126, 234, 0.4);
        }
    }

    @media (max-width: 768px) {
        width: 100%;
        max-width: 400px;
    }
`;
